module.exports = __webpack_public_path__ + "static/media/pig-red.7477909d.webp";